'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import Logo from 'ContentComponents/cmv2/fields/Logo';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { LOGO } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT, SHOW_LOADING } from 'DesignData/enums/CustomWidgetFieldAttributes';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import UISelect from 'UIComponents/input/UISelect';
import text from 'I18n/utils/unescapedText';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

const imageI18nKey = key => i18nKey(`image.showLoadingType.${key}`);

const LOADING_CONTROL_TYPES = {
  ALL: 'ALL',
  NONE: 'NONE'
};
const LOADING_CONTROL_OPTIONS = Object.keys(LOADING_CONTROL_TYPES).map(_sizeControlType => {
  return {
    text: text(imageI18nKey(`options.${_sizeControlType}`)),
    value: _sizeControlType
  };
});

class LogoContentOptions extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };

    this.onShowLoadingChange = ({
      target: {
        value: sizeControlType
      }
    }) => {
      const showLoadingControls = sizeControlType === LOADING_CONTROL_TYPES.ALL;
      this.props.editField({
        [SHOW_LOADING]: showLoadingControls
      });
    };
  }

  get loadingControlType() {
    if (this.props.field[SHOW_LOADING]) return LOADING_CONTROL_TYPES.ALL;
    return LOADING_CONTROL_TYPES.NONE;
  }

  renderShowLoading() {
    return /*#__PURE__*/_jsx(ToolFormControl, {
      className: "m-top-4",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: imageI18nKey('label')
      }),
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: imageI18nKey('tooltip')
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "module-image-field-size-dropdown",
        disabled: this.props.readOnly,
        options: LOADING_CONTROL_OPTIONS,
        onChange: this.onShowLoadingChange,
        required: true,
        value: this.loadingControlType
      })
    });
  }

  render() {
    const {
      field,
      readOnly,
      isEmail
    } = this.props;

    const label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey(`defaultLabels.${LOGO}`)
    });

    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ToolFormControl, {
        label: label,
        children: /*#__PURE__*/_jsx(SidebarInput, {
          inputComponent: Logo,
          onFieldChange: this.onDefaultChange,
          value: field[DEFAULT],
          wrap: true,
          readOnly: readOnly,
          forceShowLoading: !isEmail
        })
      }), this.renderShowLoading()]
    });
  }

}

LogoContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  isEmail: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool
};
export default LogoContentOptions;